
import { IKpiEvaluation, IKpiParams, ITableRes, IKpiEvaluationStats } from 'types'
import { baseApi } from './baseApi'

export const kpiEvaluationsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_kpiEvaluations: builder.query<ITableRes<IKpiEvaluation>, IKpiParams>({
      query: (params) => ({
        url: '/kpi-evaluations/',
        params,
      }),
      providesTags: ['kpi-evaluations'],
    }),
    GET_kpiEvaluationById: builder.query<IKpiEvaluation, string>({
      query: (id) => {
        return {
          url: `kpi-evaluations/${id}/`,
        }
      },
      providesTags: ['kpi-evaluations'],
    }),
    GET_kpiEvaluationStatsAccuracyRate: builder.query<IKpiEvaluationStats[], IKpiParams>({
      query: (params) => ({
        url: '/kpi-evaluations/stats/accuracy-rate/',
        params
      }),
      providesTags: ['kpi-evaluations'],
    }),
    GET_kpiEvaluationStatsTimeOnTask: builder.query<IKpiEvaluationStats[], IKpiParams>({
      query: (params) => ({
        url: '/kpi-evaluations/stats/time-on-task/',
        params
      }),
      providesTags: ['kpi-evaluations'],
    }),
    GET_kpiEvaluationStatsGrowthTrend: builder.query<IKpiEvaluationStats[], IKpiParams>({
      query: (params) => ({
        url: '/kpi-evaluations/stats/growth-trend/',
        params
      }),
      providesTags: ['kpi-evaluations'],
    }),
    GET_kpiStudentSubject: builder.query<any, any>({
      query: ({student, subject, params={}}) => ({
        url: `/kpi-evaluations/student/${student}/${subject}/`,
        params
      }),
      providesTags: ['kpi-evaluations'],
    }),
  }),

})

export const { 
  useGET_kpiEvaluationsQuery,
  useGET_kpiEvaluationByIdQuery,
  useGET_kpiEvaluationStatsAccuracyRateQuery,
  useGET_kpiEvaluationStatsTimeOnTaskQuery,
  useGET_kpiEvaluationStatsGrowthTrendQuery,
  useGET_kpiStudentSubjectQuery
} = kpiEvaluationsAPI
